module.exports = __webpack_public_path__ + "img/mexico-flag.d222b610.svg";